var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVendorManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 16,
    height: 16,
    transform: "translate(2.649 -0.98)",
    fill: "none",
    stroke: "#505050",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Vendor_Management"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vendor_Management",
    "data-name": "Vendor Management",
    clipPath: "url(#clip-Vendor_Management)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(-2.648 0.98)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16866",
    "data-name": "Group 16866",
    transform: "translate(1.343 0.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M17.775,5.55c1.227,0,1.84-1.322,1.84-2.69A2.38,2.38,0,0,0,19.049.925,1.669,1.669,0,0,0,17.728.5,1.773,1.773,0,0,0,15.84,2.53c0,1.793.755,3.02,1.935,3.02",
    transform: "translate(-8.427 1.702)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M15.778,14.856a2.65,2.65,0,0,1,2,2.259v.655H9.587v-.655a2.739,2.739,0,0,1,2.5-2.366l.715-.106",
    transform: "translate(-4.298 -7.638)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M8.338,1.912A1.381,1.381,0,0,0,7.244,1.56,1.468,1.468,0,0,0,5.68,3.241c0,1.486.625,2.5,1.6,2.5",
    transform: "translate(-1.719 1.002)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M10.4,12.916a1.259,1.259,0,0,0,1.007-.495",
    transform: "translate(-4.835 -6.17)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M2.517,15.865H.5v-.542a2.268,2.268,0,0,1,2.072-1.96l.592-.087",
    transform: "translate(1.701 -6.735)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M30.157,5.743c.977,0,1.6-1.017,1.6-2.5A1.468,1.468,0,0,0,30.2,1.56a1.381,1.381,0,0,0-1.095.352",
    transform: "translate(-17.185 1.002)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M29.245,12.421a1.26,1.26,0,0,0,1.007.495",
    transform: "translate(-17.28 -6.17)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M34.264,13.276l.592.087a2.269,2.269,0,0,1,2.072,1.96v.542H34.995",
    transform: "translate(-20.595 -6.735)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorManagement);
export default __webpack_public_path__ + "static/media/Vendor Management.ec48c90612d8bc36ab16613a0d34366c.svg";
export { ForwardRef as ReactComponent };